import React, { useState } from 'react';
import { useInterval } from 'react-use';
import styled from 'styled-components';
import { LFC } from '../../../Legacy';
import { ObjectManager } from '../../../concepts/objects';
import { useResolve } from '../../Container';
import { ComponentObserver } from '../visualization/ComponentObserver';
import { Colors } from './../../../ui';
import { Meeting } from './Meeting';
import { resolveActiveMeeting } from './MeetingUtil';

const Time = styled.div`
    position: relative;
    top: 0.05rem;
    margin-right: .25rem !important;
    min-width: 3.5rem;
    font-weight: 400;
`;

const TimeTicker: LFC<{ meeting: Meeting }> = ({ meeting }) => {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_tick, setTick] = useState(0);
    useInterval(() => setTick(x => x + 1), 1000);

    if (!meeting?.alive) return null;
    return <Time>{meeting.getTimeReadingFormatted()}</Time>;
};

// eslint-disable-next-line react/display-name
export const TimeIndicator = React.memo(() => {
    const meeting = resolveActiveMeeting(useResolve(ObjectManager));
    if (!meeting) return null;
    return <ComponentObserver object={meeting} render={() => <TimeTicker meeting={meeting} />} />;
});

export const StatusIndicator = styled.div<{ active?: boolean }>`
    position: relative;
    width: 1rem;
    height: 1rem;
    margin: 0 .25rem;
    background: ${p => p.active ? Colors.positive : Colors.observe};
    border-radius: 50%;
`;
